/**
 * Created by andreaskarantzas on 05.05.20.
 */
import { makeAutoObservable } from 'mobx';
import { LocalizedValue, createLocalizedValue } from '../../LocalizedValue';
import { languagePriority } from '../../LocalizedEntity';

export type NativeFeedComponentPropUrlJson = {
  url?: string;
  text: Partial<LocalizedValue>[];
};

export type NativeFeedComponentPropUrl = {
  url?: string;
  text: LocalizedValue[];
  readonly defaultText: string;
  changeText(lang: string, value: string): void;
  getText(lang: string): string;
};

export function createNativeFeedComponentPropUrl(json?: Partial<NativeFeedComponentPropUrlJson>): NativeFeedComponentPropUrl {
  return makeAutoObservable({
    url: json?.url,
    text: (json?.text ?? []).map((c: any) => createLocalizedValue(c)),

    changeText(lang: string, value: string) {
      const existing = this.text.find((n) => n.lang === lang.toLowerCase());
      if (existing) {
        existing.value = value;
      } else {
        this.text.push(
          createLocalizedValue({
            lang: lang.toLowerCase(),
            value,
          }),
        );
      }
    },

    getText(lang: string): string {
      return this.text.find((n) => n.lang === lang.toLowerCase())?.value ?? this.defaultText;
    },

    get defaultText(): string {
      for (const lang of languagePriority) {
        const entry = this.text.find((l) => l.lang === lang);
        if (entry) {
          return entry.value ?? '';
        }
      }
      const first = this.text[0];
      return first?.value ?? '';
    },
  });
}
